import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allControlGroups: [],
  allControlTemplates: [],
  newControlGroup: {},
  archiveControlTemplate: null,
  downloadData: null,
  newControlTemplate: {},
  currentGroupTemplates: {},
  currentTemplateSections: {},
  newTemplateSection: {},
  newSectionControl: {},
  selectedTemplateSection: {},
  selectedTemplateControl: {},
  templateAndSections: {},
  toggleCreateControlGroup: false,
  toggleEditControlGroup: false,
  toggleCreateControlTemplate: false,
  toggleEditControlTemplate: false,
  toggleCreateTemplateSection: false,
  toggleArchiveTemplateSection: false,
  toggleArchiveTemplateControl: false,
  toggleCreateTemplateControl: false,
  toggleUploadCsvFile: false,
  isLoading: false,
  error: [],
  // states for new reducers
  updateControlGroup: null,
  updateControlTemplate: null,
  updateTemplateSection: null,
  updateTemplateControl: null,
  archiveTemplateSection: null,
  archiveTemplateControl: null,
};

const controlGroupTemplatesSlice = createSlice({
  name: 'controlGroupTemplates',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAllControlGroups: (state, action) => {
      state.allControlGroups = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setNewControlGroup: (state, action) => {
      state.newControlGroup = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setArchiveControlTemplate: (state, action) => {
      state.archiveControlTemplate = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setTemplateAndSections: (state, action) => {
      state.templateAndSections = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setAllControlTemplates: (state, action) => {
      state.allControlTemplates = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setNewControlTemplate: (state, action) => {
      state.newControlTemplate = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setNewTemplateSection: (state, action) => {
      state.newTemplateSection = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setNewSectionControl: (state, action) => {
      state.newSectionControl = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentGroupTemplates: (state, action) => {
      state.currentGroupTemplates = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setCurrentTemplateSections: (state, action) => {
      state.currentTemplateSections = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setDownloadData: (state, action) => {
      state.downloadData = action.payload; // state not found
      state.isLoading = false;
      state.error = [];
    },
    setUploadCsvSuccess: (state) => {
      state.isLoading = false;
      state.error = [];
    },
    setValidateCsvSuccess: (state) => {
      state.isLoading = false;
      state.error = [];
    },
    setSelectedTemplateSection: (state, action) => {
      state.selectedTemplateSection = action.payload;
      state.error = [];
    },
    setSelectedTemplateControlReducer: (state, action) => {
      state.selectedTemplateControl = action.payload;
      state.error = [];
    },
    setToggleCreateControlGroup: (state) => {
      state.toggleCreateControlGroup = !state.toggleCreateControlGroup;
    },
    setToggleEditControlGroup: (state) => {
      state.toggleEditControlGroup = !state.toggleEditControlGroup;
    },
    setToggleCreateControlTemplate: (state) => {
      state.toggleCreateControlTemplate = !state.toggleCreateControlTemplate;
    },
    setToggleEditControlTemplate: (state) => {
      state.toggleEditControlTemplate = !state.toggleEditControlTemplate;
    },
    setToggleCreateTemplateSection: (state) => {
      state.toggleCreateTemplateSection = !state.toggleCreateTemplateSection;
    },
    setToggleCreateTemplateControl: (state) => {
      state.toggleCreateTemplateControl = !state.toggleCreateTemplateControl;
    },
    setToggleArchiveTemplateSection: (state) => {
      state.toggleArchiveTemplateSection = !state.toggleArchiveTemplateSection;
    },
    setToggleArchiveTemplateControl: (state) => {
      state.toggleArchiveTemplateControl = !state.toggleArchiveTemplateControl;
    },
    setToggleUploadCsvFile: (state) => {
      state.toggleUploadCsvFile = !state.toggleUploadCsvFile;
    },

    // newly created reducers
    setUpdateControlGroup: (state, action) => {
      state.updateControlGroup = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUpdateControlTemplate: (state, action) => {
      state.updateControlTemplate = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUpdateTemplateSection: (state, action) => {
      state.updateTemplateSection = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUpdateTemplateControl: (state, action) => {
      state.updateTemplateControl = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setArchiveTemplateSection: (state, action) => {
      state.archiveTemplateSection = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setArchiveTemplateControl: (state, action) => {
      state.archiveTemplateControl = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setResetControlGroup: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllControlGroups,
  setNewControlGroup,
  setArchiveControlTemplate,
  setTemplateAndSections,
  setAllControlTemplates,
  setNewControlTemplate,
  setNewTemplateSection,
  setNewSectionControl,
  setCurrentGroupTemplates,
  setCurrentTemplateSections,
  setDownloadData,
  setUploadCsvSuccess,
  setValidateCsvSuccess,
  setSelectedTemplateSection,
  setSelectedTemplateControlReducer,
  setToggleCreateControlGroup,
  setToggleEditControlGroup,
  setToggleCreateControlTemplate,
  setToggleEditControlTemplate,
  setToggleCreateTemplateSection,
  setToggleCreateTemplateControl,
  setToggleArchiveTemplateSection,
  setToggleArchiveTemplateControl,
  setToggleUploadCsvFile,
  // newly created reducers
  setUpdateControlGroup,
  setUpdateControlTemplate,
  setUpdateTemplateSection,
  setUpdateTemplateControl,
  setArchiveTemplateSection,
  setArchiveTemplateControl,
  setResetControlGroup,
} = controlGroupTemplatesSlice.actions;

export default controlGroupTemplatesSlice.reducer;
